import useOrgAccess from '_/hooks/useOrgAccess';
import { SOURCE_ENGINEER_NOT_INCLUDED } from '_/utils/userManagement';
import { ReactNode } from 'react';

interface PermitSourceEngineerProps {
  children: ReactNode;
}

function PermitSourceEngineer({ children }: PermitSourceEngineerProps): ReactNode {
  const enabled = useOrgAccess(SOURCE_ENGINEER_NOT_INCLUDED);

  return enabled ? children : null;
}

export default PermitSourceEngineer;
